import type { useLocale } from '@gov-nx/core/service';
import { DaysTillDeleteThresholds } from './useDaysTillDelete.types';

export const getDaysTillDeleteInfo = (
	daysTillDeleteSafe: number,
	t: ReturnType<typeof useLocale>['t']
) => {
	switch (daysTillDeleteSafe) {
		case DaysTillDeleteThresholds.TODAY:
			return {
				value: t('data.odstraneni-dnes'),
				prefix: t('data.odstraneni-prefix'),
			};
		case DaysTillDeleteThresholds.TOMORROW:
			return {
				value: t('data.odstraneni-zitra'),
				prefix: t('data.odstraneni-prefix'),
			};
		default:
			return {
				value: `${daysTillDeleteSafe} ${t('data.odstraneni-za-dny', { count: daysTillDeleteSafe })}`,
				prefix: t('data.odstraneni-za'),
			};
	}
};
